import { Component, ViewEncapsulation } from '@angular/core';
import { Product } from '../../models/products/products.model';
import { CommunicationService } from '../../shared/services/communication.service';

import { ApiService } from '../../shared/services/api.service';
import { ListBase } from '../../shared/components/base/list/list.base.component';

@Component({
  selector: 'swb-product-list',
  templateUrl: './../../shared/components/base/list/list.base.component.html',
  encapsulation: ViewEncapsulation.None
})
export class ProductListComponent extends ListBase<Product> {

  public url = 'products';
  public routePrefix = 'products';

  constructor(
    _apiService: ApiService,
    _communicationService: CommunicationService
  ) {
    super(
      _apiService,
      _communicationService
    );
  }

}
